import React, { useEffect } from "react";
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  Button,
  Spinner,
} from "reactstrap";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// action
import { userForgetPassword, resetForgetPassword } from "../../store/actions";

// import images
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/brands/logo-sm-light.png";

//i18n
import { withTranslation } from "react-i18next";

const ForgetPasswordPage = ({ t }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { data, error, success, loading } = useSelector(
    (state) => state.ForgetPassword
  );

  // handleValidSubmit
  const handleValidSubmit = (event, values) => {
    dispatch(userForgetPassword(values, history));
  };

  useEffect(() => {
    dispatch(resetForgetPassword());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/login" className="text-dark">
          <i className="bx bx-home h2"></i>
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-soft-primary">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">
                          {t("Password recovery")}
                        </h5>
                        <p>
                          {t(
                            "Check your inbox after the password recovery process"
                          )}
                        </p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="Tech4H" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/login">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt="Tech4H"
                            className="rounded-circle"
                            height="50"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    {error ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {error === "Invalid data"
                          ? t("Invalid data")
                          : error ===
                            "Sorry! the page you are looking for could not be found"
                          ? t(
                              "Sorry! the page you are looking for could not be found"
                            )
                          : error ===
                              "Sorry! something went wrong, please contact our support team" &&
                            t(
                              "Sorry! something went wrong, please contact our support team"
                            )}
                      </Alert>
                    ) : null}
                    {success ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {(data && data.message) ===
                          "reset token was sent to the email" &&
                          t("reset token was sent to the email")}
                      </Alert>
                    ) : null}

                    <AvForm
                      className="form-horizontal mt-4"
                      onValidSubmit={handleValidSubmit}
                    >
                      <div className="form-group">
                        <AvField
                          name="email"
                          label={t("Email")}
                          className="form-control"
                          placeholder={t("Enter email")}
                          type="email"
                          validate={{
                            required: {
                              value: true,
                              errorMessage: t("Required Field"),
                            },
                            email: {
                              value: true,
                              errorMessage: t("Incorrect email"),
                            },
                          }}
                        />
                      </div>
                      <Row className="form-group">
                        <Col className="text-right">
                          {loading ? (
                            <Button
                              disabled={true}
                              style={{
                                width: "100px",
                                cursor: "no-drop",
                              }}
                              color="primary"
                              className="mr-1 waves-effect waves-light"
                            >
                              <Spinner
                                size="sm"
                                animation="border"
                                style={{
                                  height: "19px",
                                  width: "19px",
                                }}
                              />
                            </Button>
                          ) : (
                            <Button
                              style={{
                                width: "100px",
                              }}
                              color="primary"
                              className="mr-1 waves-effect waves-light"
                              type="submit"
                              id="showtoast"
                            >
                              {t("Recover")}
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  {t("Go back to")}{" "}
                  <Link to="login" className="font-weight-medium text-primary">
                    Login
                  </Link>{" "}
                </p>
                <p>© {new Date().getFullYear()} Tech4humans.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(ForgetPasswordPage);
